/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

import UserDataResponse from "../response/login/UserDataResponse";

/**
 * Class for UserData
 */
class UserData implements UserDataResponse {
    /** The display name of the user which will be showed in the menu */
    displayName: string;

    /** Email of the user */
    email: string;

    /** Name of the user */
    name: string;

    /** Profileimage of the user */
    profileImage?: string;

    /** Username of the user */
    userName:string;

    /** Roles of the user */
    roles:string[];

    /**
     * @constructor constructs a new user
     * @param newUser - the user data
     */
    constructor(newUser?: UserDataResponse) {
        this.displayName = newUser?.displayName ?? "";
        this.email = newUser?.email ?? "";
        this.name = newUser?.name ?? "";
        this.profileImage = newUser?.profileImage;
        this.userName = newUser?.userName ?? "";
        this.roles = newUser?.roles || [];
    }

}
export default UserData